/**
 * i18n Configuration for react-i18next
 * Replaces next-intl with react-i18next for Vite
 */
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from '../../messages/en.json'
import vi from '../../messages/vi.json'

// Get locale from cookie or localStorage
function getInitialLocale(): string {
    // Check cookie first (backward compat with next-intl)
    const cookieMatch = document.cookie.match(/NEXT_LOCALE=(\w+)/)
    if (cookieMatch && ['en', 'vi'].includes(cookieMatch[1])) {
        return cookieMatch[1]
    }
    // Check localStorage
    const stored = localStorage.getItem('locale')
    if (stored && ['en', 'vi'].includes(stored)) {
        return stored
    }
    // Check browser language
    const browserLang = navigator.language.split('-')[0]
    if (['en', 'vi'].includes(browserLang)) {
        return browserLang
    }
    return 'en'
}

i18n.use(initReactI18next).init({
    resources: {
        en: { translation: en },
        vi: { translation: vi },
    },
    lng: getInitialLocale(),
    fallbackLng: 'en',
    interpolation: {
        escapeValue: false,
        prefix: '{',
        suffix: '}',
    },
})

export default i18n

export const locales = ['en', 'vi'] as const
export type Locale = (typeof locales)[number]
export const defaultLocale: Locale = 'en'

export const localeNames: Record<Locale, string> = {
    en: 'English',
    vi: 'Tiếng Việt',
}

export const localeFlags: Record<Locale, string> = {
    en: '🇺🇸',
    vi: '🇻🇳',
}

export function changeLocale(locale: Locale) {
    i18n.changeLanguage(locale)
    localStorage.setItem('locale', locale)
    document.cookie = `NEXT_LOCALE=${locale};path=/;max-age=31536000`
}
